import { AdminUser } from "../types/api";
import { create } from "zustand";
import { persist } from "zustand/middleware";
import { clearCookie } from "../config/auth";
import { removeTokenFromStorage } from "../utils/token-utils";

export interface AuthState {
  admin: AdminUser | null;
  token: string | null;
  isAuthenticated: boolean;

  authorize: (admin: AdminUser, token: string) => void;
  logout: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      admin: null,
      token: null,
      isAuthenticated: false,

      authorize: (admin, token) => set({ admin, token, isAuthenticated: true }),
      logout: () => {
        // Clear the auth token from localStorage using utility function
        removeTokenFromStorage();

        // Clear the auth token cookie
        clearCookie("authToken");

        set({
          admin: null,
          token: null,
          isAuthenticated: false,
        });
      },
    }),
    {
      name: "auth",
      partialize: (state) => ({
        admin: state.admin,
        token: state.token,
        isAuthenticated: state.isAuthenticated,
      }),
      onRehydrateStorage: () => (state) => {
        if (state) {
          useAuthStore.setState(state);
        }
      },
    }
  )
);

export const selectAuthToken = (state: AuthState) => state.token;
export const selectAuthAdmin = (state: AuthState) => state.admin;
export const selectIsAuthenticated = (state: AuthState) =>
  state.isAuthenticated;

export const selectAuthorize = (state: AuthState) => state.authorize;
export const selectLogout = (state: AuthState) => state.logout;
